import { render, staticRenderFns } from "./AppAlert.vue?vue&type=template&id=0017d04d&"
import script from "./AppAlert.vue?vue&type=script&lang=js&"
export * from "./AppAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
